import React, { Component } from "react"

import SEO from "../components/seo"
import Layout from "../components/layout"
import Hero from "../components/home/Hero"
import Intro from "../components/home/Intro"
// import Ecosystem from "../components/home/Ecosystem"
import Ecosystem from "../components/home/NewEcoSystem"
import BuildOnCeler from "../components/home/BuildOnCeler"
import SupportedChains from "../components/home/SupportedChains"

export default class IndexPage extends Component {
  render() {
    return (
      <Layout>
        <SEO title="Celer Network" />
        <Hero />
        <Intro />
        <Ecosystem />
        <BuildOnCeler />
        <SupportedChains />
      </Layout>
    )
  }
}
